import { Flexi } from "slotworks/graphics/elements/abstract-flexi";
import Translations from "slotworks/i18n/translations";
import DeviceInfo from "slotworks/utils/device-info";

export default class FlexiText extends Flexi<PIXI.Text | HTMLElement> {
    public setText(text: string) {
        for (const target of this.targets) {
            if (target instanceof HTMLElement) {
                target.innerText = text;

                target.innerHTML = Translations.convertTags(target.innerText);
            } else {
                // TODO: This fixes iOS not updating gradient text. Can be removed when fixed in pixi
                if (DeviceInfo.isAppleDevice() || DeviceInfo.isSafari()) {
                    target.text = "";
                    try {
                        target.updateTransform();
                        (target as any).updateText();
                        (target as any).updateTexture();
                    } catch (e) {
                        // Sometimes an error is thrown. Since this is temporary anyway, we just ignore it
                    }
                }

                target.text = text;
            }
        }
    }

    public setAlpha(alpha: number) {
        for (const target of this.targets) {
            if (target instanceof HTMLElement) {
                target.style.opacity = alpha.toString();
            } else {
                target.alpha = alpha;
            }
        }
    }

    public setVisible(visible: boolean) {
        for (const target of this.targets) {
            if (target instanceof HTMLElement) {
                target.classList.toggle(visible ? "hidden" : "visible", false);
                target.classList.toggle(visible ? "visible" : "hidden", true);
            } else {
                target.visible = visible;
            }
        }
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/graphics/elements/flexi-text.ts